export const VIDEO_FORMATS = ['video/mp4', 'video/webm', 'video/ogg'];
export const IMAGE_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/svg+xml'];
export const ANIMATED_FORMATS = ['image/gif', 'image/apng'];
export const MEDIA_LIMIT_HEIGHT_CLASSES = 'h-[70vh] aspect-video md:aspect-auto';
